module.exports = __webpack_public_path__ + "img/smiley_off.74313b67.gif";